<template>
    <div class="outer">

        <el-dialog
        width="55%" 
        :title="numPriceTitle" 
        :close-on-click-modal="false" 
        :visible="numPriceVisible"
        @close="closeNumPriceDialog">
            <el-card style="margin-bottom: 30px;">
                <el-form ref="goodsForm" :model="goodsForm" :rules="goodsRules" label-width="120px">
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物类别">
                                <el-input disabled v-model="goodsForm.goodsClassName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物名称">
                                <el-input disabled v-model="goodsForm.goodsName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="品牌">
                                <el-input disabled v-model="goodsForm.goodsBrand" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物型号">
                                <el-input disabled style="width: 100%" v-model="goodsForm.goodsType" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="生产厂商">
                                <el-input disabled style="width: 100%" v-model="goodsForm.manufacturer" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物单位">
                                <el-select disabled style="width: 100%" v-model="goodsForm.goodsUnit" placeholder="请选择">
                                    <el-option v-for="(item,i) in unitList" :key="i" :value="item" :label="item">{{item}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物配置">
                                <el-input disabled style="width: 100%" type="textarea" v-model="goodsForm.goodsConfig" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="备注">
                                <el-input disabled style="width: 100%" type="textarea" v-model="goodsForm.remarks" placeholder="无"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="数量" required prop="goodsNum">
                                <el-input style="width: 100%" type="number" v-model="goodsForm.goodsNum" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="采购单价(元)" required prop="factPurchasePrice">
                                <el-input style="width: 100%" type="number" v-model="goodsForm.factPurchasePrice" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item prop="factPurchaseSubtotal">

                                <div slot="label">
                                    
                                    <el-popover trigger="hover" placement="top">
                                        <p size="medium" style="white-space: nowrap">
                                            采购小计非必填,若输入则优先级最高,会覆盖掉数量乘单价的数据
                                        </p>
                                        <div slot="reference">
                                            采购小计(元)<i class="el-icon-info"></i>
                                        </div>
                                    </el-popover>
                                </div>
                                <el-input style="width: 100%" type="number" v-model="goodsForm.factPurchaseSubtotal" placeholder="请输入采购总价"></el-input>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="numPriceVisible = false">取 消</el-button>
                <el-button type="primary" @click="numPriceSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog width="55%" :close-on-click-modal="false" title="选择货物" :visible="checkGoodsVisible" @close="checkGoodsVisible = false">
            <addGoods @checkGoods="checkGoods"/>
        </el-dialog>

        <el-dialog width="60%" :close-on-click-modal="false" :title="buyOrderTitle" :visible="addOrderVisible" @close="closeAddOrder">

            <el-card style="margin-bottom: 30px;">
                <div class="flex-space-between" slot="header">
                    <span>采购单基本信息</span>
                </div>
                <el-form ref="buyOrderForm" :model="buyOrderForm" :rules="buyOrderRules" label-width="120px">

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="项目名称" required prop="chanceId">
                                <el-select style="width: 100%" :disabled="buyOrderType === 'detail' || buyOrderType == 'storage'" v-model="buyOrderForm.chanceId" filterable placeholder="请选择">
                                    <el-option v-for="(item,i) in projectList" :key="i" :label="item.name" :value="item.id">
                                        {{ item.name }}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="供应商名称" required prop="supplierId">
                                <el-select style="width: 100%" :disabled="buyOrderType === 'detail' || buyOrderType == 'storage'" filterable v-model="buyOrderForm.supplierId" placeholder="请选择">
                                    <el-option v-for="(item,i) in suppliers" :key="i" :value="item.id" :label="item.supplierName">
                                        {{item.supplierName}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="优惠折扣率(%)" prop="discountRate">
                                <el-input style="margin-right: 10px;" :disabled="buyOrderType === 'detail' || buyOrderType == 'storage'" v-model="buyOrderForm.discountRate" type="number" placeholder="请输入折扣率,原价则不填"> </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="实际采购日期" required class="queryCol" prop="purchaseDate">
                                <el-date-picker
                                style="width: 100%"
                                :disabled="buyOrderType === 'detail' || buyOrderType == 'storage'"
                                v-model="buyOrderForm.purchaseDate"
                                type="date"
                                placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        
                        <el-col :span="11">
                            <el-form-item label="发货类型"  required prop="purchaseState">
                                <el-select style="width: 100%" :disabled="buyOrderType === 'detail' || buyOrderType == 'storage'" v-model="buyOrderForm.purchaseState" placeholder="请选择">
                                    <el-option value="0" label="直发到客户">直发到客户</el-option>
                                    <el-option value="1" label="入云擎仓库">入云擎仓库</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="备注" prop="remarks">
                                <el-input style="width: 100%" v-if="buyOrderType === 'detail' || buyOrderType == 'storage'" disabled type="textarea" v-model="buyOrderForm.remarks" placeholder="无"></el-input>
                                <el-input style="width: 100%" v-else type="textarea" v-model="buyOrderForm.remarks" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    
                </el-form>
            </el-card>

            <el-card>
                <div class="flex-space-between" slot="header">
                    <span>采购单货物信息</span>
                    <div>
                        <el-button icon="el-icon-position" type="primary" v-if="buyOrderType !== 'detail' && buyOrderType !== 'storage'" @click="checkGoodsVisible = true">选择货物</el-button>
                        <el-button icon="el-icon-s-home" type="primary" v-else-if="buyOrderForm.purchaseState == 1 && buyOrderType === 'storage'" @click="inventory">全部入库</el-button>
                    </div>   
                </div>
                <el-table
                style="width: 100%;max-height: 500px;overflow: auto;"
                :row-class-name="tabRowClassName"
                :data="buyOrderForm.tbPurchaseGoodsList">
                    <el-table-column
                        align="center"
                        label="货物名称"
                        prop="goodsName">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="货物类别"
                        prop="goodsClassName">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="货物型号"
                        prop="goodsType">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="货物配置"
                        width="250"
                        prop="goodsConfig">
                        <template slot-scope="scope"> 
                            <el-popover trigger="hover" placement="top" width="300">
                                <p>{{ scope.row.goodsConfig }}</p>
                                    <div slot="reference">
                                    <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                </div>
                            </el-popover>        
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="货物单位"
                        prop="goodsUnit">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="采购数量"
                        prop="goodsNum">
                    </el-table-column>
                    <template v-if="buyOrderType == 'storage' && buyOrderForm.purchaseState == 0">
                        <el-table-column
                        align="center"
                        label="已退货入库数量"
                        prop="storageCount">
                            <template slot-scope="scope">
                                {{ parseInt(scope.row.storageCount) || 0 }}
                            </template>
                        </el-table-column>
                    </template> 
                    <el-table-column
                        align="center"
                        label="采购单价(元)"
                        prop="factPurchasePrice">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="采购小计(元)"
                        prop="factPurchaseSubtotal">
                    </el-table-column>
                    <el-table-column
                        min-width="130"
                        align="center"
                        label="操作"
                        prop="operate"
                        v-if="!((buyOrderType == 'storage' && buyOrderForm.purchaseState == 1) || (buyOrderType == 'detail'))">
                        <template slot-scope="scope" >
                            <template v-if="buyOrderType !== 'detail' && buyOrderType !== 'storage'">
                                <el-button type="text" icon="el-icon-edit" @click="openNumPrice('edit',scope.row)">修改</el-button>
                                <el-button type="text" icon="el-icon-delete" @click="deleteGoods(scope.$index)">删除</el-button>
                            </template>
                            <el-button v-else type="text" icon="el-icon-s-home" @click="backGoodsInventory(scope.row)">退货入库</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="totalPrice">
                    <div class="price" :key="totalKey">合计: {{ AmountPayable }}元</div>
                    <div class="price">应付金额
                        <el-tooltip content="应付金额等于优惠折扣率乘以合计金额" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                        : {{ buyOrderForm.amountPayable.toFixed(2) }}元</div>
                </div>
            </el-card>

            <span slot="footer" class="dialog-footer" >
                <el-button @click="addOrderVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="submitBuyOrderDisable" @click="buyOrderSubmit" v-if="buyOrderType !== 'detail' && buyOrderType !== 'storage'">确 定</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline>
                <el-form-item label="发货类型" class="queryCol">
                    <el-select v-model="queryForm.purchaseState" clearable @clear="onSearch" @change="onSearch">
                        <el-option :value="0" label="直发到客户">直发到客户</el-option>
                        <el-option :value="1" label="入云擎仓库">入云擎仓库</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="项目名称" class="queryCol">
                    <el-select v-model="queryForm.projectName" @change="onSearch" clearable @clear="onSearch" filterable placeholder="请选择">
                        <el-option v-for="(item,i) in projectList" :key="i" :label="item.name" :value="item.id">
                            {{ item.name }}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-plus" @click="openbuyOrderDialog('add')">
                新建采购单
            </el-button>
        </div>

        <el-table
        v-loading="loading"
        class="table"
        :data="tableData"
        style="margin-bottom: 20px;width: 100%;height: 68vh;overflow: auto;">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column
                align="center"
                label="采购单编号"
                prop="purchaseNo">
                <template slot-scope="scope">
                    <el-button 
                    type="text" 
                    @click="openbuyOrderDialog('detail',scope.row)" >
                    {{ scope.row.purchaseNo }}
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="商机号"
                prop="chanceId">
            </el-table-column>
            <el-table-column
                align="center"
                label="项目名称"
                prop="projectName">
            </el-table-column>
            <el-table-column
                align="center"
                label="供应商名称"
                prop="supplierName">
            </el-table-column>
            <el-table-column
                align="center"
                label="供应商联系人"
                prop="linkMan">
            </el-table-column>
            <el-table-column
                align="center"
                label="联系人电话"
                prop="phone">
            </el-table-column>
            <el-table-column
                align="center"
                label="发货类型">
                <template slot-scope="scope">
                    <el-tag type="primary" effect="dark" v-if="scope.row.purchaseState == 0 ">
                        直发到客户
                    </el-tag>
                    <el-tag v-if="scope.row.purchaseState == 1">
                        入云擎仓库
                    </el-tag>
                </template> 
            </el-table-column>
            <el-table-column
                align="center"
                v-if="queryForm.purchaseState == 1"
                label="入库状态">
                <template slot-scope="scope">
                    {{ inventoryStateText(scope.row) }}
                </template> 
            </el-table-column>
            <el-table-column
                align="center"
                label="实际采购日期"
                prop="purchaseDate">
            </el-table-column>
            <el-table-column
                align="center"
                label="创建时间"
                prop="createTime"
                min-width="130"
                
                :formatter="dateTimeTwoLine"
                class-name="cell-two-line"
                >
            </el-table-column>
            <el-table-column
                align="center"
                label="操作"
                width="200"
                prop="operate">
                <template slot-scope="scope">
                    <el-button
                    type="text" 
                    icon="el-icon-edit" 
                    @click="openbuyOrderDialog('edit',scope.row)" 
                    v-if="!scope.row.storageTimes">
                        修改
                    </el-button>
                    
                    <template v-if="scope.row.purchaseState == 0">
                        <el-button 
                        type="text" 
                        icon="el-icon-document" 
                        @click="openbuyOrderDialog('storage',scope.row)">
                            {{ '退货入库' }}
                        </el-button>
                    </template>
                    <template v-else-if="scope.row.purchaseState == 1">
                        <el-button 
                        type="text" 
                        icon="el-icon-document" 
                        @click="openbuyOrderDialog('storage',scope.row)" 
                        v-if="!scope.row.storageTimes">
                            {{ '到货入库' }}
                        </el-button>
                    </template>
                    <el-button 
                        v-if="scope.row.purchaseState == 1 && scope.row.storageTimes"
                        type="text">
                        --
                    </el-button>
                    <el-button
                    type="text" 
                    icon="el-icon-delete"
                    style="color: #F56C6C"
                    @click="deletePurchase(scope.row.id)" 
                    v-if="!scope.row.storageTimes">
                        删除
                    </el-button>
                    
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :total="total"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageSize"
            :current-page="page"
            background
            layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import { getSupplierList, getUnits } from '@/api/goods/goodsBusiness.js';
import { getAllProject, getPurchaseList, addPurchaseList, queryPurchaseGoodList, updatePurchaseGoodList, deletePurchaseGoodList } from '@/api/goods/buyOrder.js';
import { storgeAllGoods, storageGoodsInWarehouse } from '@/api/goods/inventory.js';
import addGoods from './addGoods.vue';
export default {
   data() {
    // 优惠折扣率校验
    var checkRate = (rule, value, callback) => {
        console.log(value);
        if(value && (value > 100 || value <=0 || value.toString().includes('.'))){
            callback(new Error('请输入0到100的正整数'));
        } else{
            callback();
        }
    }
    // 货物数量校验
    var checkGoodsNum = (rule, value, callback) => {

        if(!value){
            return callback(new Error('请输入货物数量'));
        }
        if(value <=0 || value.toString().includes('.')){
            callback(new Error('请输入正整数'));
        } else{
            callback();
        }
    }

    // 货物单价校验
    var checkPrice = (rule, value, callback) => {

        if(!value){
            return callback(new Error('请输入货物单价'));
        }
        if(value <=0){
            callback(new Error('请输入正数'));
        } else{
            callback();
        }
    }
    return {
    submitBuyOrderDisable: false, // 提交按钮禁用
    totalKey: 0, 
    unitList: [], // 单位列表
    checkGoodsVisible: false, // 选中货物弹窗
    numPriceTitle: '', 
    suppliers: [], // 供应商列表
    buyOrderForm: {
        chanceId: '',
        supplierId: '',
        discountRate: '',
        purchaseDate: '',
        purchaseState: '',
        remarks: '',
        amountPayable: 0,
        tbPurchaseGoodsList:[],
    }, // 采购单的表单
    buyOrderRules:{
        chanceId:[
            { required: true, message: '请选择项目' },
        ],
        supplierId:[
            { required: true, message: '请选择供应商' },
        ],
        discountRate:[
            { validator: checkRate, type: 'change' }
        ],
        // amountPayable:[
        //     { required: true, message: '请选择应付金额' }
        // ],
        purchaseDate:[
            { required: true, message: '请选择实际采购日期' },
        ],
        purchaseState:[
            { required: true, message: '请选择发货类型' },
        ],
    }, // 采购单表单验证规则
    goodsForm: {
        goodsNum: '',
        factPurchasePrice: '',
    }, 
    goodsRules: {
        goodsNum: [
            { validator:checkGoodsNum, type: 'change' }
        ],
        factPurchasePrice:[
            { validator:checkPrice, type: 'change' }
        ]
    },
    queryForm: {
        projectName: '',
        purchaseState: '',
    },
    tableData: [],
    serialList: [{}], // 序列号列表
    form: {},
    rules: {},
    projectList: [],
    rvisible: false,
    pvisible: false,
    goodsList: [],
    ivisible: false,
    addOrderVisible: false, // 新增采购订单弹窗的显隐
    numPriceVisible: false, // 填写数量和价格的弹窗
    page: 1,
    pageSize: 10,
    total: 0, // 总条目数
    loading: false, // 列表加载
    numPriceType: '', // 填写数量和单价弹窗类型: add: 新增 edit: 修改
    buyOrderType: '', // 采购单表单弹窗类型: add: 新增 edit: 修改
    buyOrderTitle: '', // 采购单表单弹窗标题
    }
   },
   components:{
    addGoods
   },
   async created(){
    await this.getTableList();
    await this.getProjectList();
    await this.getSupplierList();
    this.getUnitList();
   },
   computed:{
    AmountPayable(){
        
        let payAble = this.buyOrderForm.tbPurchaseGoodsList.reduce((total, item) => {
            if(item.isDel != 1){
                return total + (item.factPurchaseSubtotal) * 1
            }else{
                return total
            }
        }, 0)

        return payAble
    }
   },
   watch:{
    'buyOrderForm.tbPurchaseGoodsList':{
        handler(newTbList){
            this.buyOrderForm.amountPayable = this.AmountPayable * (this.buyOrderForm.discountRate || 100) * 0.01
        },
        deep: true
    },
    'buyOrderForm.discountRate':{
        handler(discountRate){
            this.buyOrderForm.amountPayable = this.AmountPayable * (discountRate || 100) * 0.01
        }
    }

   },
   methods:{
    // 删除该供应商
    deletePurchase(id){
        this.$confirm('确定删除该采购单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletePurchaseGoodList({id}).then((res) => {
                if(res.code === 200){
                    this.getTableList();
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }
            })
          
        })
    },
    // 退货入库
    backGoodsInventory(row){
        this.$prompt(`退货入库数量(剩余数量: ${row.goodsNum - (parseInt(row.storageCount) || 0)})`, '退货入库', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'number',
        inputValidator: (value) => {
            if(value > (row.goodsNum - parseInt(row.storageCount))){
                return '退货入库数量不能大于剩余数量'
            }
        },
        inputPattern: /[^ \x20]+/,
        inputErrorMessage: '退货入库数量为空',
        }).then(({ value }) => {
            storageGoodsInWarehouse({
                purchaseNo: this.buyOrderForm.purchaseNo,
                goodsCode: row.goodsCode,
                goodsNum: value,
                category: this.buyOrderForm.category
            }).then(res => {
                if(res.code === 200){
                    this.$message({
                        type: 'success',
                        message: '入库成功'
                    });
                    this.addOrderVisible = false;
                    this.getTableList();
                }
            })
        })
    },
    // 入库状态
    inventoryStateText(row){
        if(row.purchaseState == 1){
            if(row.storageTimes && row.storageTimes>=1){
                return '已入库';
            } else {
                return '未入库';
            }
        }
    },
    // 入库
    inventory(){
        this.$confirm('是否将采购单中的货物一次性全部入库', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            storgeAllGoods({id:this.buyOrderForm.id}).then(res => {
                if(res.code === 200){

                    this.$message({
                        type: 'success',
                        message: '入库成功'
                    });
                    this.addOrderVisible = false;
                    this.getTableList();
                }
            })
        })
    },
    tabRowClassName({row}){
        if(row.isDel == 1){
            return 'warning-row'
        }
        return ''
    },
    // 打开采购单表单页面
    openbuyOrderDialog(type, item){
        console.log(item);
        this.buyOrderType = type;
        if(type === 'add'){
            this.buyOrderTitle = '新建采购单';
            this.addOrderVisible = true;
        }else if(type === 'edit'){
            this.buyOrderTitle = '修改采购单';
            this.buyOrderForm = { ...item, tbPurchaseGoodsList: [] };
            queryPurchaseGoodList({ purchaseNo: item.purchaseNo }).then(res => {
                if(res.code === 200){
                    this.buyOrderForm.tbPurchaseGoodsList = res.data;
                    this.addOrderVisible = true;
                    this.totalKey ++;
                }
            })
        }else if(type === 'storage'){
            this.buyOrderForm = { ...item,tbPurchaseGoodsList: [] };
            this.buyOrderTitle = this.buyOrderForm.purchaseState == 0 ? '退货入库' : '到货入库';
            queryPurchaseGoodList({ purchaseNo: item.purchaseNo }).then(res => {
                if(res.code === 200){
                    this.buyOrderForm.tbPurchaseGoodsList = res.data;
                    this.addOrderVisible = true;
                    this.totalKey ++;
                }
            })
        }else{
            this.buyOrderForm = { ...item,tbPurchaseGoodsList: [] };
            this.buyOrderTitle = '采购单详情';
            queryPurchaseGoodList({ purchaseNo: item.purchaseNo }).then(res => {
                if(res.code === 200){
                    this.buyOrderForm.tbPurchaseGoodsList = res.data;
                    this.addOrderVisible = true;
                    this.totalKey ++;
                }
            })

        }
    },
    // 关闭添加采购单弹窗
    closeAddOrder(){
        this.buyOrderForm = {
            tbPurchaseGoodsList: []
        };
        this.$refs.buyOrderForm.resetFields();
        this.addOrderVisible = false;
    },
    // 新增采购单表单提交
    buyOrderSubmit(){
        
        this.$refs.buyOrderForm.validate((valid)=>{
            
            if(valid){
                if(this.buyOrderForm.tbPurchaseGoodsList.length <= 0){
                    this.$message({
                        type: 'error',
                        message: '货物列表为空!'
                    });
                    return;
                }
                this.submitBuyOrderDisable = true;

                let addOrderForm = {...this.buyOrderForm};
                
                addOrderForm.discountRate = addOrderForm.discountRate ? this.buyOrderForm.discountRate : 100;
                
                addOrderForm.tbPurchaseGoodsList = this.buyOrderForm.tbPurchaseGoodsList.map((item,i) => {
                    return {
                        xh: i+1,
                        goodsCode:item.goodsCode,
                        goodsNum:item.goodsNum,
                        factPurchasePrice:item.factPurchasePrice,
                        factPurchaseSubtotal: item.factPurchaseSubtotal,
                        isDel: item.isDel || 0,
                    }
                })

                if(this.buyOrderType === 'add'){
                    addPurchaseList(addOrderForm).then(res => {
                        if(res.code === 200){
                            this.$message({
                                type: 'success',
                                message: '新建采购单成功!'
                            });
                            
                            this.addOrderVisible = false;
                            this.page = 1;
                            this.getTableList();
                            this.submitBuyOrderDisable = false;
                        }
                    })
                }else if(this.buyOrderType === 'edit'){
                    updatePurchaseGoodList(addOrderForm).then(res => {
                        if(res.code === 200){
                            this.$message({
                                type: 'success',
                                message: '修改采购单成功!'
                            });
                            this.addOrderVisible = false;
                            this.page = 1;
                            this.getTableList();
                            this.submitBuyOrderDisable = false;
                        }
                    })
                }
                
            }
        })
    },
    // 关闭数量和单价的弹窗
    closeNumPriceDialog(){
        this.$refs.goodsForm.resetFields();
        this.numPriceVisible = false;
    },
    // 删除货物
    deleteGoods(index){
        this.$confirm('确定删除该货物', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            console.log(this.buyOrderForm.tbPurchaseGoodsList);
            if(this.buyOrderForm.tbPurchaseGoodsList.length <= 1){
                this.$message({
                    type: 'error',
                    message: '采购单至少保留一种货物!'
                });
                return;
            }
            if(this.buyOrderType === 'add'){
                this.buyOrderForm.tbPurchaseGoodsList.splice(index,1);
            }else if(this.buyOrderType === 'edit'){
                this.buyOrderForm.tbPurchaseGoodsList[index].isDel = 1;
            }
        })
    },
    // 搜索
    onSearch(){
        this.page = 1;
        this.getTableList();
    },
    // 当每页条数变化
    onSizeChange(e){
        this.page = 1;
        this.pageSize = e;
        this.getTableList();
    },
     // 获取单位列表
    getUnitList(){
        getUnits().then(res => {
            if(res.code === 200){
                this.unitList = res.data
            }
        })
    },
    // 当页码发生变化时
    onCurrentChange(e){
        this.page = e;
        this.getTableList();
    },
    // 获取采购单列表数据
    async getTableList(){
        this.loading = true;
        await getPurchaseList({
            page: this.page,
            limit: this.pageSize,
            projectName: this.queryForm.projectName,
            purchaseState: this.queryForm.purchaseState
        }).then(res => {
            if(res.code === 200){
                this.tableData = res.data;
                this.total = res.total;
                this.loading = false;
            }
        })
    },
    // 获取所有的项目列表
    async getProjectList(){
        await getAllProject().then(res => {
            if(res.code === 200){
                this.projectList = res.data;
            }
        })
    },
    // 填写货物数量和单价弹窗的确认按钮
    numPriceSubmit(){
        this.$refs.goodsForm.validate((valid) => {
            if(valid){
                // 新增填写信息
                if(this.numPriceType === 'add'){


                    let hasGoods;
                    hasGoods = this.buyOrderForm.tbPurchaseGoodsList.find(item => {
                        return item.goodsCode === this.goodsForm.goodsCode
                    })
                    if(hasGoods){
                        this.numPriceVisible = false;
                        // this.checkGoodsVisible = true;
                        this.$message({
                            type: 'error',
                            message: '该采购单选择过该货物,请选择其他货物'
                        });
                        return;
                    }
                    if(!this.goodsForm.factPurchaseSubtotal){
                        this.goodsForm.factPurchaseSubtotal = this.goodsForm.goodsNum * this.goodsForm.factPurchasePrice
                    }
                    
                    this.buyOrderForm.tbPurchaseGoodsList.push({...this.goodsForm});
                    this.numPriceVisible = false;

                }else if (this.numPriceType === 'edit'){ // 修改填写信息
                    let index = this.buyOrderForm.tbPurchaseGoodsList.findIndex(item => {
                        return item.goodsCode === this.goodsForm.goodsCode
                    })
                    if(!this.goodsForm.factPurchaseSubtotal){
                        this.goodsForm.factPurchaseSubtotal = this.goodsForm.goodsNum * this.goodsForm.factPurchasePrice
                    }
                    this.buyOrderForm.tbPurchaseGoodsList.splice(index, 1, {...this.goodsForm});
                    this.numPriceVisible = false;
                }
                
            }
        })
        
    },
    // 打开货物数量和单价的弹窗
    openNumPrice(type,item){
        this.goodsForm = {...item};
        this.numPriceType = type;
        this.numPriceTitle = '修改货物数量和单价';
        this.numPriceVisible = true;
    },
    // 选择货物
    checkGoods(item){
        this.numPriceType = 'add'
        this.numPriceTitle = '填写货物数量和单价';
        this.checkGoodsVisible = false;
        this.numPriceVisible = true;
        this.goodsForm = {...item};
    },
    // 获取供应商列表
    async getSupplierList(){
        await getSupplierList({page: 1, limit: 9999, category: "商务"}).then(res => {
            if(res.code === 200){
                this.suppliers = res.data;
            }
        })
    }
   },
}
</script>
<style lang="scss" scoped>
.outer{
    height: 85vh;
    overflow: auto;

    .el-form-item{
        margin-right: 20px;
    }

    .el-table{
        &::before{
            display: none;
        }
        ::v-deep .warning-row{
            display: none;
        }
    }

    .totalPrice{
        display: flex;
        justify-content: flex-end;
        margin-top: 15px; 
        font-size: 16px;

        .price{
            margin-right: 20px
        }
    }

    .pageination{
        display: flex; 
        justify-content: flex-end;
        margin-top: 5px
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }
}
</style>
